import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Spinner } from 'react-bootstrap';
import PaginatedTable from '../../components/PaginatedTable';
import api from '../../services/api';
import { useInterfaceStore } from '../../stores/useInterfaceStore';
import { notify } from '../../stores/useNotificationStore';

interface IUser {
  id: number;
  nome: string;
  email: string;
  telefone: string;
  departamento: string;
  tipo_pessoa: string;
  empresa_id: number;
}

const UserListPage: React.FC = () => {
  const [users, setUsers] = useState<IUser[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { empresaId } = useInterfaceStore();

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const response = await api.getUsers(empresaId ?? undefined);
        if (response.success && response.data) {
          setUsers(response.data as IUser[]);
        } else {
          setError('Erro ao carregar usuários.');
        }
      } catch {
        setError('Falha de conexão ao buscar usuários.');
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, [empresaId]);

  const handleDelete = async (item: IUser) => {
    if (!window.confirm(`Tem certeza que deseja excluir o usuário "${item.nome}"?`)) return;
    try {
      const response = await api.deleteUser(item.id);
      if (response.success) {
        setUsers(prev => prev.filter(u => u.id !== item.id));
      } else {
        notify.error('Falha ao excluir o usuário.');
      }
    } catch {
      notify.error('Erro de conexão ao excluir o usuário.');
    }
  };

  const handleEdit = (item: IUser) => {
    navigate(`/app/usuarios/${item.id}`);
  };

  if (loading) {
    return (
      <div className="p-4 text-center">
        <Spinner animation="border" /> <span>Carregando usuários...</span>
      </div>
    );
  }

  const columns: { key: keyof IUser; title: string }[] = [
    { key: 'id', title: 'ID' },
    { key: 'nome', title: 'Nome' },
    { key: 'email', title: 'E-mail' },
    { key: 'tipo_pessoa', title: 'Perfil' },
    { key: 'departamento', title: 'Área/Departamento' },
  ];

  return (
    <>
      <div className="mb-4">
        <h2>Listagem de Usuários</h2>
        <p className="text-muted">Visualize, edite ou exclua os usuários cadastrados no sistema.</p>
      </div>
      {error && <Alert variant="danger">{error}</Alert>}
      <PaginatedTable<IUser>
        data={users}
        columns={columns}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />
    </>
  );
};

export default UserListPage;
